import React from "react";
import "./colourBoxes.scss";

const ColourBoxes = ({
  bgImg,
  icon,
  title,
  description,
  bgColor = "#FF9900",
}) => {
  return (
    <>
      <div
        className="colour_box_wrapper"
        style={{ background: `${bgColor}CC` }}
      >
        <img src={bgImg} alt="background" className="bg_img" />
        <img src={icon} alt="mission" className="colour_box_icon" />
        <h2 className="section_heading72">{title}</h2>
        <p
          className="section_desc20"
          dangerouslySetInnerHTML={{ __html: description }}
        ></p>
      </div>
    </>
  );
};

export default ColourBoxes;
